declare namespace $ {

	type $mol_check_expand__checked_shm_hitalama_textbook_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['toc_expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_hitalama_textbook_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['toc_expandable'] >
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_link__arg_shm_hitalama_textbook_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['toc_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_textbook_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_hitalama_textbook_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_textbook_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['toc_children'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_shm_hitalama_textbook_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['toc_node_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_shm_hitalama_textbook_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['toc_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_shm_hitalama_textbook_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_textbook_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_textbook_text__param_shm_hitalama_textbook_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['text_param'] >
		,
		ReturnType< $shm_hitalama_textbook_text['param'] >
	>
	type $shm_hitalama_textbook_text__text_shm_hitalama_textbook_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['text'] >
		,
		ReturnType< $shm_hitalama_textbook_text['text'] >
	>
	type $mol_page__title_shm_hitalama_textbook_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textbook['text_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_textbook_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_hitalama_textbook extends $mol_book2 {
		toc_expanded( id: any, next?: boolean ): boolean
		toc_expandable( id: any): boolean
		Toc_expand( id: any): $mol_check_expand
		toc_arg( id: any): Record<string, any>
		toc_title( id: any): string
		Toc_link( id: any): $mol_link
		Toc_row( id: any): $mol_view
		toc_children( id: any): readonly(any)[]
		Toc_children( id: any): $mol_list
		toc_node_rows( id: any): readonly(any)[]
		Toc_node( id: any): $mol_list
		toc_rows( ): readonly(any)[]
		Toc( ): $mol_list
		Toc_page( ): $mol_page
		text_title( ): string
		text_param( ): string
		text( ): string
		Text( ): $shm_hitalama_textbook_text
		Text_page( ): $mol_page
		menu_title( ): string
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=textbook.view.tree.d.ts.map